import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ProjectAccessService } from '@masar/core/services';
import { NotificationService } from 'mnm-webapp';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ProjectAccessGuard implements CanActivate {
    public constructor(
        private readonly projectAccessService: ProjectAccessService,
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly translateService: TranslateService
    ) {}

    public canActivate(
        _activatedRoute: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.projectAccessService.getAccess().pipe(
            map(access => access.canAccess),
            tap(hasAccess => {
                if (!hasAccess) {
                    this.router.navigate(['']).then();
                    this.translateService
                        .get(
                            'translate_you_do_not_have_the_permission_to_access_this_page'
                        )
                        .subscribe(str => {
                            this.notificationService.notifyError(str);
                        });
                }
            })
        );
    }
}
